<script>
  export default {
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$nextTick(function () {
        // MetsiMenu
        $('#side-menu').metisMenu();
      });
    },
    computed: {
      
    }
  }
</script>

<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header" style="padding: 33px 12px;">
          <div class="dropdown profile-element">
            <span>
              <img alt="image" class="img-responsive" src="img/logo.png">
            </span>
          </div>
          <div class="logo-element">
            {{ configuracao.abreviaturaFundacao }}
          </div>
        </li>
        <!--<router-link tag="li" :to="{ name: 'transparencia.principal' }" exact="">
    <a>
      <i class="fa fa-th-large"></i>
      <span class="nav-label">Página Inicial</span>
    </a>
  </router-link>-->
        <router-link tag="li" :to="{ name: 'transparencia.projetos' }" exact="">
          <a>
            <i class="fa fa-th-large"></i>
            <span class="nav-label">Projetos</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'transparencia.institucional' }" exact=""
                     v-if="configuracao.acessarInstitucionalPortalTransparencia">
          <a>
            <i class="fa fa-university"></i>
            <span class="nav-label">Institucional</span>
          </a>
        </router-link>

        <router-link tag="li" :to="{ name: 'transparencia.verificar.pagamento' }" exact=""
                     v-if="configuracao.mostrarVerificacaoPagamentoPortalTransparencia">
          <a>
            <i class="fa fa-money"></i>
            <span class="nav-label">Verificação de Pagamento</span>
          </a>
        </router-link>
        <!--<li>
    <a href="#"><i class="fa fa-sitemap"></i> <span class="nav-label">Menu Levels </span><span class="fa arrow"></span></a>
    <ul class="nav nav-second-level collapse">
      <li>
        <a href="#">Third Level <span class="fa arrow"></span></a>
        <ul class="nav nav-third-level">
          <li>
            <a href="#">Third Level Item</a>
          </li>
          <li>
            <a href="#">Third Level Item</a>
          </li>
          <li>
            <a href="#">Third Level Item</a>
          </li>

        </ul>
      </li>
      <li><a href="#">Second Level Item</a></li>
      <li>
        <a href="#">Second Level Item</a>
      </li>
      <li>
        <a href="#">Second Level Item</a>
      </li>
    </ul>
  </li>-->
      </ul>
    </div>
  </nav>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/MenuTransparencia.vue